import { Bot, TimeFrame } from '../../types';

/* ======================================   getTimeFrameIntervalTimestamp   ====================================== */
export const getTimeFrameIntervalTimestamp = (timeFrame: TimeFrame) => {
  let timestamp;

  switch (timeFrame) {
    case TimeFrame.OneYear:
      timestamp = 1000 * 60 * 60 * 24 * 7 * 4 * 12;
      break;

    case TimeFrame.OneQuarter:
      timestamp = 1000 * 60 * 60 * 24 * 7 * 4 * 3;
      break;

    case TimeFrame.TwoMonths:
      timestamp = 1000 * 60 * 60 * 24 * 7 * 4 * 2;
      break;

    case TimeFrame.OneMonth:
      timestamp = 1000 * 60 * 60 * 24 * 7 * 4;
      break;

    case TimeFrame.ThreeWeeks:
      timestamp = 1000 * 60 * 60 * 24 * 7 * 3;
      break;

    case TimeFrame.TwoWeeks:
      timestamp = 1000 * 60 * 60 * 24 * 7 * 2;
      break;

    case TimeFrame.OneAndHalfWeek:
      timestamp = 1000 * 60 * 60 * 24 * 10.5;
      break;

    case TimeFrame.OneWeek:
      timestamp = 1000 * 60 * 60 * 24 * 7;
      break;

    case TimeFrame.HalfWeek:
      timestamp = 1000 * 60 * 60 * 24 * 3.5;
      break;

    case TimeFrame.TenDays:
      timestamp = 1000 * 60 * 60 * 24 * 10;
      break;

    case TimeFrame.SixDays:
      timestamp = 1000 * 60 * 60 * 24 * 6;
      break;

    case TimeFrame.FiveDays:
      timestamp = 1000 * 60 * 60 * 24 * 5;
      break;

    case TimeFrame.FourDays:
      timestamp = 1000 * 60 * 60 * 24 * 4;
      break;

    case TimeFrame.ThreeDays:
      timestamp = 1000 * 60 * 60 * 24 * 3;
      break;

    case TimeFrame.TwoDays:
      timestamp = 1000 * 60 * 60 * 24 * 2;
      break;

    case TimeFrame.OneDay:
      timestamp = 1000 * 60 * 60 * 24;
      break;

    case TimeFrame.HundredHours:
      timestamp = 1000 * 60 * 60 * 100;
      break;

    case TimeFrame.TwentyHours:
      timestamp = 1000 * 60 * 60 * 20;
      break;

    case TimeFrame.EighteenHours:
      timestamp = 1000 * 60 * 60 * 18;
      break;

    case TimeFrame.FifteenHours:
      timestamp = 1000 * 60 * 60 * 15;
      break;

    case TimeFrame.TwelveHours:
      timestamp = 1000 * 60 * 60 * 12;
      break;

    case TimeFrame.TenHours:
      timestamp = 1000 * 60 * 60 * 10;
      break;

    case TimeFrame.EightHours:
      timestamp = 1000 * 60 * 60 * 8;
      break;

    case TimeFrame.SixHours:
      timestamp = 1000 * 60 * 60 * 6;
      break;

    case TimeFrame.FiveHours:
      timestamp = 1000 * 60 * 60 * 5;
      break;

    case TimeFrame.FourHours:
      timestamp = 1000 * 60 * 60 * 4;
      break;

    case TimeFrame.ThreeHours:
      timestamp = 1000 * 60 * 60 * 3;
      break;

    case TimeFrame.TwoHours:
      timestamp = 1000 * 60 * 60 * 2;
      break;

    case TimeFrame.OneHour:
      timestamp = 1000 * 60 * 60;
      break;

    case TimeFrame.HundredMinutes:
      timestamp = 1000 * 60 * 100;
      break;

    case TimeFrame.SeventyFiveMinutes:
      timestamp = 1000 * 60 * 75;
      break;

    case TimeFrame.FiftyMinutes:
      timestamp = 1000 * 60 * 50;
      break;

    case TimeFrame.FortyMinutes:
      timestamp = 1000 * 60 * 40;
      break;

    case TimeFrame.ThirtyMinutes:
      timestamp = 1000 * 60 * 30;
      break;

    case TimeFrame.TwentyMinutes:
      timestamp = 1000 * 60 * 20;
      break;

    case TimeFrame.FifteenMinutes:
      timestamp = 1000 * 60 * 15;
      break;

    case TimeFrame.TenMinutes:
      timestamp = 1000 * 60 * 10;
      break;

    case TimeFrame.EightMinutes:
      timestamp = 1000 * 60 * 8;
      break;

    case TimeFrame.SixMinutes:
      timestamp = 1000 * 60 * 6;
      break;

    case TimeFrame.FiveMinutes:
      timestamp = 1000 * 60 * 5;
      break;

    case TimeFrame.FourMinutes:
      timestamp = 1000 * 60 * 4;
      break;

    case TimeFrame.ThreeMinutes:
      timestamp = 1000 * 60 * 3;
      break;

    case TimeFrame.TwoMinutes:
      timestamp = 1000 * 60 * 2;
      break;

    case TimeFrame.OneMinute:
      timestamp = 1000 * 60;
      break;

    default:
      timestamp = 0;
      break;
  }

  return timestamp;
};

export const calculateStartTimestampByTimeFrame = (
  timeFrame: TimeFrame | undefined,
) => {
  if (!timeFrame) {
    return new Date('2022').valueOf();
  }

  return new Date().valueOf() - 100 * getTimeFrameIntervalTimestamp(timeFrame);
};

export const getMinimumZoomByTimeFrame = (timeFrame: TimeFrame | undefined) => {
  switch (timeFrame) {
    case TimeFrame.OneWeek:
      return 8500000000;

    case TimeFrame.OneDay:
      return 8500000000 / 2;

    case TimeFrame.FourHours:
      return 8500000000 / 6;

    default:
      return 8500000000;
  }
};

export const getSelectedTimeFrame = (
  bot: Bot,
  selectedTimeFrameIndex: number,
) => {
  if (!bot.timeFrame) {
    return TimeFrame.OneWeek;
  }

  switch (selectedTimeFrameIndex) {
    case 0:
      return bot?.timeFrame.multiOrder;

    case 1:
      return bot?.timeFrame.shorter;

    case 2:
      return bot?.timeFrame.higher;
    default:
      return TimeFrame.OneWeek;
  }
};
